<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'日计划管理'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <!-- <el-form-item label="创客">
						<el-input v-model="q.userCode" placeholder="请输入创客姓名/工号" :clearable="true"></el-input>
					</el-form-item> -->
                    <el-form-item  label="拜访日期">
                        <el-date-picker type="date" placeholder="选择日期" v-model="q.visitDate"
                        value-format="yyyy-MM-dd" style="width: 100%;">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="创客">
                        <el-input v-model="q.planUserName" placeholder="请输入创客名称"></el-input>
                    </el-form-item>
                    <el-form-item label="拜访客户">
                        <el-input v-model="q.customerName" placeholder="请输入拜访客户名称"></el-input>
                    </el-form-item>
                    <el-form-item label="部门">
                      <el-select filterable v-model="q.cdept" clearable placeholder="请选择"
                      >
                        <el-option
                            v-for="(item,index) in deptList"
                            :key="item.dept"
                            :label="item.dept"
                            :value="item.dept">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  <el-form-item label="区域" style="margin-left: 27px">
                    <brselect v-model="q.quyuCode" :v="q.quyuCode" category="show_area" :clearable="true"></brselect>
                  </el-form-item>
                </el-form>

                <!-- 展开搜素 -->
                <div class="l-screenBox">
                    <!-- <div class="l-screen" @click="collapseChange">
                        <img :src="isScreen?closeScreen:drawScreen" alt="">
                        <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                    </div> -->
                    <div class="l-retrieval">
                    <el-button class="h-btn h-formBtn" @click="selectPageAll">检索</el-button>
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                    <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                        新建目标
                    </el-button>
                    </div>
                </div>
            </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"

                    :data="tableData"
                    :border="true"
                    stripe
                    max-height="560"
                    style="width: 100%" >
                        <el-table-column
                            label="序号"
                            type="index"
                            width="50">
                        </el-table-column>
                        <el-table-column prop="cuname" label="创客" min-width="12%" ></el-table-column>
                        <el-table-column prop="deptName" label="部门" min-width="12%" ></el-table-column>
                        <el-table-column prop="quyuName" label="区域" min-width="12%" ></el-table-column>
                        <el-table-column prop="projectName" label="项目分类" min-width="15%" ></el-table-column>
<!--                        <el-table-column prop="chainGroupName" label="抢入链群" width="180" ></el-table-column>-->
                        <el-table-column prop="customerName" label="拜访客户" min-width="25%" ></el-table-column>
                    <el-table-column prop="visitContent" show-overflow-tooltip="" label="拜访内容" min-width="25%" ></el-table-column>
                    <el-table-column prop="visitDate" label="拜访日期" min-width="12%">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        fixed="right"
                        min-width="15%">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="openNissin(scope.row)"
                            >日清</el-button>
                            <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="updateDetail(scope.row)"
                            >编辑</el-button>
                          <el-button
                              type="text"
                              size="small"
                              class="h-tableLink h-btn"
                              @click="deleteSingle(scope.row.id)"
                          >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 弹出层 -->
            <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>{{titleDig}}</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <div style="padding: 12px;">
                        <el-form :model="add" label-position="right" :inline="true" label-width="80"
                                class="demo-ruleForm h-formbLine h-formbLine1">
                            <el-form-item label="年度" class="h-elformWrap-3" prop="username">
                                <el-select filterable v-model="add.year"  placeholder="请选择"
                                    @change="getWeeksBySelectYear">
                                    <el-option
                                            v-for="(item) in yearList"
                                            :key="item"
                                            :label="item"
                                            :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="周" class="h-elformWrap-3" prop="week">
                                <el-select filterable @change="selectWeek" v-model="add.week"  placeholder="请选择">
                                    <el-option
                                            v-for="(item) in weekList"
                                            :key="item.week"
                                            :label="item.weekStr"
                                            :value="item.week">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <div style="width: 96%;margin: 0 auto;padding-bottom: 10px;">
                                <!-- <el-checkbox-group  v-model="add.userList" @change="groupChange">
                                    <el-checkbox
                                        v-for="(item, index) in authTypeList"
                                        value="item.id"
                                        :key="index"
                                        :label="item.id"
                                        class="checkbox-div"
                                    > {{item.projectName}}-{{item.targetContent}}</el-checkbox>
                                </el-checkbox-group> -->

                                 <el-radio-group  v-model="add.userList" @change="changeHandler">
                                    <el-radio class="radio"  v-for="(item, index) in authTypeList" value="item.id"
                                        :key="index"
                                        :label="item.id"> {{item.projectName}}-{{item.targetContent}}</el-radio>

                                </el-radio-group>


                            </div>
                            <el-form-item label="客户名称" prop="euName" >
                                <el-select v-model="add.customerName"  :disabled="disEdit"
                                     :filter-method="showFormList"  placeholder="请输入"
                                    :remote-method="showFormList" @change="showFormList" >
                                    <el-option v-for="(item) in optionList"
                                                :key="item.id"
                                                :label="item.deptName"
                                                :value="item.deptName">
                                    </el-option>
                                </el-select>
                              <i class="el-icon-circle-plus" @click="createLxr" ></i>
                            </el-form-item>
                            <!-- <el-form-item label="客户名称">
                                <el-autocomplete
                                    v-model="add.customerName"
                                    size="mini"
                                    :fetch-suggestions="querySearchGroup"
                                    @select="selectGroup"

                                    @input="groupListMe"
                                    :disabled="disEdit"
                                    clearable
                                    placeholder="请输入内容"
                                ></el-autocomplete> -->

                                 <!-- <el-input v-model="add.customerName" :disabled="disEdit"></el-input> -->
                            <!-- </el-form-item> -->
                            <el-form-item label="拜访时间">
                                 <el-date-picker
                                    v-model="add.visitDateNew"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="项目分类">
                                <el-select v-model="add.projectName" :disabled="disEdit">
                                    <el-option v-for="(item) in projectList"
                                                :key="item.id"
                                                :label="item.projectName"
                                                :value="item.projectName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="拜访内容" class="h-elformWrap-1">
                                 <el-input type="textarea"  v-model="add.targetContent" :disabled="disEdit"></el-input>
                            </el-form-item>
                            <el-form-item style="display:none">
                                <el-input v-model="add.clearType"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
                    </div>
                </div>
            </el-dialog>
          <!-- 日清 -->
          <el-dialog :close-on-click-modal="false" :visible.sync="writeNissin" class="h-dialog2">
            <div class="h-dialogImg">
              <div class="h-disTable">
                <div class="h-tableCell">
                  <h1>{{titleDig}}</h1>
                </div>
              </div>
            </div>
            <div class="h-formLines">
              <div style="padding: 12px;">
                <el-form :model="add" label-position="right" :inline="true" label-width="80"
                         class="demo-ruleForm h-formbLine h-formbLine1">
                  <div style="width: 96%;margin: 0 auto;padding-bottom: 10px;">
                    <el-checkbox-group v-if="edit.clearType == 1"  v-model="edit.userList" @change="groupChangeEdit">
                      <el-checkbox
                          v-for="(item) in authTypeListEdit"
                          :key="item.id"
                          :label="item.id"
                          :value= "item.id"
                          class="checkbox-div"
                      > {{item.projectName}}-{{item.targetContent}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div class="h-formLine">
                  <el-form-item  label="客户名称" prop="department" >
                    <el-input v-model="nissin.customerName" disabled>
                    </el-input>
                  </el-form-item>
                  <el-form-item  label="项目分类" prop="department" >
                    <el-input v-model="nissin.projectName" disabled>
                    </el-input>
                  </el-form-item>h
                  <el-form-item  label="计划内容" prop="department"  class="h-elformWrap-1">
                    <textarea v-model="nissin.visitContent" disabled style="width:100%; height: 70px" >
                    </textarea>
                  </el-form-item>
                  </div>

                  <div class="h-formLine projectCon"><p><i>日清提报</i></p>

<!--                  <el-form-item  label="联系人" prop="contactUserName" >-->
<!--                    <el-input v-model="nissin.contactUserName" placeholder="请输入">-->
<!--                    </el-input>-->
<!--                  </el-form-item>-->

                    <el-form-item label="联系人" prop="customerName">
                      <el-select v-model="nissin.contactUserName" remote filterable :filter-method="showGroupList" :clearable="true"
                                 style="width: 135px;"
                                 placeholder="请输入"
                                 :remote-method="showGroupList" @change="showGroupList" >
                        <el-option v-for="(item,index) in contactUserNameList"
                                   :key="index"
                                   :label="item.fullName"
                                   :value="item.fullName">
                        </el-option>
                      </el-select>
                      <i class="el-icon-circle-plus" @click="createLxr"></i>
                    </el-form-item>
                  <el-form-item  label="部门科室" prop="department" >
                    <el-input v-model="nissin.department" placeholder="请输入部门/科室/岗位">
                    </el-input>
                  </el-form-item>


                  <el-form-item  label="联系电话" prop="telephone" >
                    <el-input v-model="nissin.telephone" onkeyup="value=value.replace(/[^\d]/g,'')"  placeholder="请输入">
                    </el-input>
                  </el-form-item>

                  <el-form-item label="抢入链群" prop="lianqun">
                    <brselect category="crm_lianqun" :v="nissin.lianqunCode" :showcode="true"
                              v-model="nissin.lianqunCode" clearable></brselect>
                  </el-form-item>

                  <el-form-item label="日清内容" class="h-elformWrap-1">
                    <textarea v-model="nissin.dailyContent" placeholder="请输入" style="width:100%; height: 70px">
                    </textarea>
                  </el-form-item>
                  <el-form-item style="display:none">
                    <el-input v-model="nissin.dailyContent"></el-input>
                  </el-form-item>
                  </div>
                </el-form>
              </div>
              <div style="display:flex;justify-content:center;margin-bottom:20px">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                <!--                    <el-button class="h-btn h-bBtn h-bggreen" @click="saveCreate" v-show="isShowSaveCredit">暂存-->
                <!--                    </el-button>-->
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveNissin()">保存</el-button>
              </div>
            </div>
          </el-dialog>
            <!-- 编辑 -->
            <el-dialog :close-on-click-modal="false" :visible.sync="editDialog" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>{{titleDig}}</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <div style="padding: 12px;">
                        <el-form :model="add" label-position="right" :inline="true" label-width="80"
                                class="demo-ruleForm h-formbLine h-formbLine1">
                            <div style="width: 96%;margin: 0 auto;padding-bottom: 10px;">
                                <el-checkbox-group v-if="edit.clearType == 1"  v-model="edit.userList" @change="groupChangeEdit">
                                    <el-checkbox
                                        v-for="(item) in authTypeListEdit"
                                        :key="item.id"
                                        :label="item.id"
                                        :value= "item.id"
                                        class="checkbox-div"
                                    > {{item.projectName}}-{{item.targetContent}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <el-form-item label="客户名称">
                                <el-autocomplete
                                    v-model="edit.customerName"
                                    size="mini"
                                    :fetch-suggestions="querySearchGroup1"
                                    @select="selectGroup1"
                                    @input="groupListMe1"
                                    :disabled="disEdit"
                                    clearable
                                    placeholder="请输入内容"
                                ></el-autocomplete>
                                 <!-- <el-input v-model="add.customerName" :disabled="disEdit"></el-input> -->
                            </el-form-item>
                            <el-form-item label="拜访时间">
                                 <el-date-picker
                                    v-model="edit.visitDateNew"
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="项目分类">
                                <el-select v-model="edit.projectName" :disabled="disEdit">
                                    <el-option v-for="(item) in projectList"
                                                :key="item.id"
                                                :label="item.projectName"
                                                :value="item.projectName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="拜访内容" class="h-elformWrap-1">
                                 <el-input type="textarea"  v-model="edit.targetContent"  :disabled="disEdit"></el-input>
                            </el-form-item>
                            <el-form-item style="display:none">
                                <el-input v-model="edit.clearType"></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                        <!--                    <el-button class="h-btn h-bBtn h-bggreen" @click="saveCreate" v-show="isShowSaveCredit">暂存-->
                        <!--                    </el-button>-->
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate()">保存</el-button>
                    </div>
                </div>
            </el-dialog>

          <!-- 新建联系人-->
          <el-dialog :close-on-click-modal="false"  @close='closeDialogLxr' :visible.sync="newDialogLxr" class="h-dialog2">
            <div class="h-dialogImg">
              <div class="h-disTable">
                <div class="h-tableCell">
                  <h1>{{titleDig}}</h1>
                </div>
              </div>
            </div>
            <div class="h-formLines">
              <el-form :model="addLxr" label-position="right" :inline="true" label-width="80" :rules="editFormRules" class="demo-ruleForm h-formbLine h-formbLine1">
<div style="height: 20px"></div>
                <el-form-item  label="姓名" prop='fullName'>
                  <el-input v-model="addLxr.fullName"  placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item label="客户名称" prop="custName" >
                  <el-select v-model="addLxr.custName" remote
                             filterable :filter-method="showFormList" clearable placeholder="请输入"
                             :remote-method="showFormList" @change="showFormList" >
                    <el-option v-for="(item) in optionList"
                               :key="item.id"
                               :label="item.userName"
                               :value="item.userName">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item  label="负责人" prop='leader' >
                  <el-input v-model="addLxr.leader" placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item  label="部门" prop='dept' >
                  <el-input v-model="addLxr.dept" placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item  label="职务" prop='dept' >
                  <el-input v-model="addLxr.job" placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item
                    label="性别"
                    prop="sex"
                >
                  <el-radio-group v-model="addLxr.sex">
                    <el-radio :label='0' >男</el-radio>
                    <el-radio :label='1'>女</el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item  label="手机" prop='mobilephone'
                               :rules="[
                {
                  pattern: /^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/,
                  message: '请输入正确的手机号码'
                }
              ]">
                  <el-input v-model="addLxr.mobilephone" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item  label="电话" prop='telephone'
                               :rules="[
                {
                  pattern: /[0-9-()（）]{7,18}/,
                  message: '请输入正确的电话号码'
                }
                ]">
                  <el-input v-model="addLxr.telephone" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item  label="邮件" prop='email'
                               :rules="[
                {
                  pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                  message: '请输入正确邮件'
                }
                ]"
                >
                  <el-input v-model="addLxr.email"  placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item  label="地址" prop='address'>
                  <el-input v-model="addLxr.address"  placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item label="生日">
                  <el-date-picker
                      v-model="addLxr.birthday"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>

                <el-form-item
                    label="决策人"
                    prop="policyMaker"
                >
                  <el-radio-group v-model="addLxr.policyMaker">
                    <el-radio :label='0'>否</el-radio>
                    <el-radio :label='1'>是</el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item  label="毕业院校" prop='finishSchool' >
                  <el-input v-model="addLxr.finishSchool" placeholder="请输入">{{addLxr.finishSchool}}
                  </el-input>
                </el-form-item>

                <el-form-item  label="业余兴趣" prop='interest' >
                  <el-input v-model="addLxr.interest" placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item  label="国家级科研项目" prop='project' >
                  <el-input v-model="addLxr.project"  placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item label="备注" class="h-elformWrap-1" >
                  <el-input type="textarea"  v-model="addLxr.memo" placeholder="请输入"></el-input>
                </el-form-item>

                <el-form-item label="专家级别" class="h-elformWrap-1">
                  <el-input type="textarea" v-model="addLxr.expertlevel" placeholder="请输入" class="h-txtareaBox" rows="3" clearable></el-input>
                </el-form-item>

              </el-form>
              <div style="display:flex;justify-content:center;margin-bottom:20px">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="exitLxr">取消</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreateLxr()">提交</el-button>
              </div>
            </div>
          </el-dialog>
          <!-- 新建用户单位-->
          <el-dialog :close-on-click-modal="false"  @close='closeDialogUser' :visible.sync="institutionalX" class="h-dialog2">
            <companyName ref="companyName" :titleName = "titleDig" :add1 = "addUser" :stVal="stVal" @getChildValue="closeCompanyName"></companyName>
          </el-dialog>
<!--          <el-dialog :close-on-click-modal="false"  @close='closeDialogUser' :visible.sync="newDialogUser" class="h-dialog2">
            <div class="h-dialogImg">
              <div class="h-disTable">
                <div class="h-tableCell">
                  <h1>{{titleDig}}</h1>
                </div>
              </div>
            </div>
            <div class="h-formLines">
              <el-form ref="form" :model="addUser" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                <el-form-item  label="单位名称" class="h-elformWrap-2" label-width="100" prop="deptName" :rules="[{ required: true, message: '请输入单位名称', trigger: 'blur'},]">
                  <el-select v-model="addUser.deptName"  remote filterable :filter-method="selectDept" clearable placeholder="请输入" allow-create filterable
                             :remote-method="selectDept" @change="selectDept">
                    <el-option v-for="(item) in deptNameList"
                               :key="item.deptName"
                               :label="item.deptName"
                               :value="item.deptName">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item  label="渠道" class="h-elformWrap-2" label-width="100" prop="deptSourceChannel" :rules="[{ required: true, message: '请选择渠道', trigger: 'blur'},]">
                  <brselect category="sales_region" :v="addUser.deptSourceChannel" :showcode="true"
                            v-model="addUser.deptSourceChannel" clearable></brselect>
                </el-form-item>
                <el-form-item label="省" class="h-elformWrap-2" prop="province" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
                  <el-select v-model="addUser.province" @change="handleItemChange1" placeholder="省"  style="width: 68%;">
                    <el-option
                        v-for="item in shenglist"
                        :key="item.value"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="市" class="h-elformWrap-2" prop="city"
                              :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
                  <el-select v-model="addUser.city" @change="handleItemChange2"
                             :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                             placeholder="市"  style="width: 68%;">
                    <el-option
                        v-for="item in arealist2"
                        :key="item.value"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="区" class="h-elformWrap-2" prop="area"
                              :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
                  <el-select v-model="addUser.area"
                             :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                             placeholder="区" style="width: 68%;" @change="handleItemChange3">
                    <el-option
                        v-for="item in arealist3"
                        :key="item.value"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="上级" class="h-elformWrap-1" label-width="100" prop="deptName">
                  <treeselect
                      :multiple="false"
                      :options="options"
                      :flat="true"
                      :default-expand-level="1"
                      placeholder="请选择"
                      v-model="stVal"
                  />
                  <treeselect-value :value="stVal" />
                </el-form-item>
                <el-form-item label="详细地址" class="h-elformWrap-1"
                              :rules="[
                        { required: true, message: '必须输入选项', trigger: 'blur'},
                        {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                    ]"
                              prop="address">
                  <el-input v-model="addUser.address" style="width: 84%;"></el-input>
                </el-form-item>
              </el-form>
              <div style="display:flex;justify-content:center;margin-bottom:20px">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="exitUser">取消</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreateUser()">提交</el-button>
              </div>
            </div>
          </el-dialog>-->
        </div>
      <div class="h-tableB h-mrt30">
        <div class="h-tableBL" style="margin-left: 23px">
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                     @click="exportExcel">批量导出
          </el-button>
        </div>
        <div class="h-pagination2">
            <pagination :page="q" @query="selectPageAll" />
        </div>
      </div>
    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import cost from '../../../routes/cost';
import uploaddownexcelbyrole from "../../../components/uploaddown/uploaddownexcelbyrole";
import companyName from "@/components/basic/companyName.vue";
export default {
  components: {
    companyName,
    Treeselect
  },
    data() {
        return {
          institutionalX:false,
          editFormRules: {
            fullName: [{required: true, message: '请输入必填项', trigger: 'blur'}],
            custName: [{required: true, message: '请输入必填项', trigger: 'blur'}],
          },
          contactUserNameList:[],// 联系人s
          addLxr: {
            id: '',
            fullName: '',
            custName: '',
            custCode: '',
            leader: '',
            dept: '',
            job: '',
            sex: null,
            mobilephone: '',
            telephone: '',
            email: '',
            address: '',
            birthday: '',
            policyMaker: null,
            achievingRate: '',
            finishSchool: '',
            expertlevel: '',
            interest: '',
            project: '',
            memo: '',
          },
            q:{
                visitDate:'',
                planUserName:'',
                customerName:'',
                quyuCode:'',
                pageNo:1,
                pageSize:10,
                total:0,
            },
            size:'',
            tableData: [],
            newDialog:false,
            writeNissin:false,
            editDialog:false,
            // 展开折叠筛选
            isScreen:false,
            yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
            weekList:[],
            add:{
                year:'',
                week:'',
                userList:[0],
                targetContent:'',
                customerName:'',
                customerCode:'11',
                visitDateNew:'',
                clearType:'2',
                projectName:''
            },
            edit:{
                id:'',
                deId:'',
                userList:[0],
                targetContent:'',
                customerName:'',
                visitDateNew:'',
                clearType:'',
                projectName:''
            },
            nissin:{
              answerTime:'',
              defultFlag:'',
              dailyQuestion:'',
              customerName:'',
              visitDate:'',
              endDate:'',
              visitContent:"",
              dailyContent:'',
              isProject: 0,
              id:'',
              isConShow:false,
              isProjectBtn:false,
              chainGroupName:'',
              chainGroupCode:'',
              visitEffect:'',
              title:'',
              statusR:'',
              selectVisitEffect:['a','b'],
              gameTitles: [],
              subJieProgess: [], // 需求子节点数据
              childMsgId: '',
              //yucePrice: '', // 月预算在下单
              expConvDate: '',
              department:'',
              telephone:'',
              contactUserName:"",
              lianqunCode:'',
            },
            addUser: {
              id: '',
              deptName: '',
              deptType: '',
              leader: '',
              phone: '',
              email: '',
              status: '',
              countryId: '',
              country: '',
              provinceId: '',
              province: '',
              cityId: '',
              city: '',
              areaId: '',
              landmark:'',
              area: '',
              address: '',
              shengobj: '',
              shiobj: '',
              quobj: '',
              selectId: '',
              subFlag: '',
              deptSourceChannel:'',
              longitude:'',
              latitude:'',
              parentCode:'',
            },
            proSelect: {
              pcode: 0,
              level: 1,
            },
          newDialogLxr:false,
          newDialogUser:false,
            stVal:null,
            deptNameList:[],
            shenglist: [],
            arealist2: [],
            arealist3: [],
            options:[],
            authTypeListEdit:[],
            wirteNissinList:[],
            disEdit:false,

            workList:[],
            AuthoCheck: '',
            authTypeList: [],
            userList: [0],
            weekPlanList:[],
            groupList: [],
            groupArr:[],
            deptList: [],
            titleDig:"",
            optionList:[],
            projectList:[],
        }
    },
    methods: {
    // 根据客户获取联系人
      showGroupList(value) {
let this_ = this ;
        ss.MuBiao.getLxr(this._data.nissin.customerName).then(res => {
          this.contactUserNameList = res.msg.filter(t=> t.fullName.indexOf(value)!=-1);//res.msg.finter
          console.log(this.contactUserNameList)
          let st = this.contactUserNameList.find(t=>t.fullName==value);
          this.nissin.department=st.dept;
          this.nissin.telephone=st.telephone==''?st.mobilephone:st.telephone;;
          //lxrDq.telephone==''?lxrDq.mobilephone:lxrDq.telephone;
          console.log(st)
          // this.addLxr.c = res[0].id
        })
      },
      //明细导出
      exportExcel() {
        updownfile.down("/api/swyl/v1/dailyClear/userDailyClear/newDownloadExcel",this.q,"post",'data');
      },
        // getOption(){
        //     this.optionList=[]
        //     var data  = ''
        //      ss.MuBiao.getUser(data).then(res => {
        //         console.log(res)
        //         this.optionList = res
        //      })
        // },
        showFormList(value) {
            ss.MuBiao.getUser(value).then(res => {
                this.optionList = res.msg.length>100? res.msg.slice(0, 100):res.msg;
            })
        },
        //项目类型
        getProject(){
            ss.MuBiao.getProject().then(res => {
                console.log(res)
                this.projectList = res.msg
            })
        },
        getDept(q){
          ss.MuBiao.getDeptList(q).then(rd => {
            this.deptList = rd;
          })
        },
      createLxr(){
        this.titleDig = "新建联系人"
        this.newDialogLxr = true;
        this.addLxr.custName=this.nissin.customerName;
        // this.loadArea();
      },
        createAddress() {
          this.titleDig = "新建用户单位"
          this.institutionalX = true
          /*this.loadArea();*/
        },
      closeCompanyName(propData){
        console.log(propData);
        this.closeDialogUser();
      },
        loadArea(i) {
          ss.Dictservice.arealist(this.proSelect).then(rd => {
            this.shenglist = rd;
            // for(let i = 0; i < this.shenglist.length; i++){
            //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
            // }
            console.log("shenglist",this.shenglist)
          })
        },
        groupChangeEdit() {
            if (this.edit.userList.length > 1) {
                this.edit.userList.shift();
            }
            console.log(this.edit.userList)
            var arr3 =[]
            this.edit.userList.forEach((item) => {
                this.authTypeListEdit.forEach((element) => {
                    if (item == element.id) {
                        arr3.push(element)
                    }
                })
            })
            console.log(arr3)
            if(arr3.length == 0){
                this.edit.targetContent = '',
                this.edit.customerName= ''
                //this.add.visitDateNew= ''
                this.edit.clearType = 2
                this.disEdit = false
            }else{
                this.edit.targetContent = arr3[0].targetContent,
                this.edit.customerName= arr3[0].customerName
                this.edit.clearType = 1
                this.disEdit = true
                this.edit.deId = this.edit.userList[0]
            }
        },
        commitUpdate(){
            var data ={
                id:this.edit.id,
                deId:this.edit.deId,
                targetContent:this.edit.targetContent,
                customerName:this.edit.customerName,
                visitDate:this.edit.visitDateNew,
                clearType:this.edit.clearType,
                visitContent:this.edit.targetContent,
                projectName:this.edit.projectName
            }
            console.log("data",data)
            ss.MuBiao.updateById(data).then(res =>{
                console.log(res)
                if(res.f == true ){
                    this.editDialog= false
                    console.log(res)
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.selectPageAll()
                    this.newDialog = false
                }else{
                    this.$message.error(res.msg);
                }
            })
        },


        openNissin(row){
            var data1 ={
              visitDate:row.visitDate,
            }
              ss.MuBiao.canDailyClear(data1).then(s =>{
                if(s.f == true){
                  //console.log(res)
                  console.log("data1",data1)
                  // console.log(res)
                  this.writeNissin = true,
                      this.wirteNissinList = [];
                  this.titleDig="日清提报";
                  this.nissin = row;
                  this.nissin.isProject = 0;
                  var data = this.nissin
                  // this.$message({
                  //   message: res.msg,
                  //   type: 'success'
                  // });
                  this.selectPageAll()
                  this.newDialog = false
                  //ss.MuBiao.checkPunchPage(data1).then(res =>{

                    // if(res.f == true ){
                    //
                    // }else{
                    //   this.$message.error(res.msg);
                    // }
                  //})
                }else{
                  this.$message.error(s.msg);
                }
              })
        },
      saveNissin(){
        this.nissin.chainGroupCode = this.nissin.lianqunCode
        var data = this.nissin
        var list = [];
        this.chainGroupCode = data.lianqunCode;
        list.push(data);
        console.log("data",data);
        console.log("list",list);
        ss.MuBiao.submitDaily(list).then(res =>{
              console.log(res)
          if(res.f == true ){
            this.writeNissin= false
            console.log(res)
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.selectPageAll()
            this.newDialog = false
          }else{
            this.$message.error(res.msg);
          }
        })

      },



        updateDetail(row){
            //
            this.authTypeListEdit=[]
            this.titleDig="编辑内容"
            var data = row.id
            ss.MuBiao.getDailyPlanSingle(data).then(res =>{
                console.log(res.msg)
                this.authTypeListEdit = res.msg.detailList1
                if(res.msg.clearType == 1){
                    var obj=res.msg.detailList1.find(function (obj) {
				      return obj.status ==1//取出this.studentL里的id为1的那条数据所有的信息
                    })
                    this.disEdit = true
                    this.edit.deId = obj.id
                }else{
                    this.disEdit = false
                    this.edit.deId = res.msg.detailList1[0].id
                }
                //res.msg.id
                this.edit.userList.push("202108077fbF2uAn")
                this.edit.id = res.msg.id
                this.edit.customerName = row.customerName
                this.edit.projectName = row.projectName
                this.edit.visitDateNew = row.visitDate
                this.edit.targetContent = row.visitContent
                this.edit.clearType = res.msg.clearType
            })
            console.log(row)
            this.editDialog = true
        },
        groupListMe() {
            var data  = this.add.customerName
             ss.MuBiao.getUser(data).then(res => {
                console.log(res)
                this.groupList = []
                this.groupArr = []
                this.groupList = res
                for(let item of this.groupList) {
                    this.groupArr.push({
                      value:item.deptName,
                      id:item.id
                    })
                }
             })
        },
        querySearchGroup(queryString, cb) {
            var groupArr = this.groupArr;
            cb(groupArr);
        },
        selectGroup(val) {
            console.log(val)
             this.add.customerName= val.value
        },
        groupListMe1() {
            var data  = this.edit.customerName
             ss.MuBiao.getUser(data).then(res => {
                console.log(res)
                this.groupList = []
                this.groupArr = []
                this.groupList = res
                for(let item of this.groupList) {
                    this.groupArr.push({
                      value:item.deptName,
                      id:item.id
                    })
                }
             })
        },
        querySearchGroup1(queryString, cb) {
            var groupArr = this.groupArr;
            cb(groupArr);
        },
        selectGroup1(val) {
            console.log(val)
             this.edit.customerName= val.value
        },
        commitCreate() {
            console.log(this.add)
            var data =[{
                year:this.add.year,
                week:this.add.week,
                targetContent:this.add.targetContent,
                customerName:this.add.customerName,
                visitDate:this.add.visitDateNew,
                clearType:this.add.clearType,
                customerCode:this.add.customerCode,
                id:this.add.id,
                projectName:this.add.projectName
            }]
            console.log(data)
            ss.MuBiao.insertAll(data).then(res => {
                console.log(res)
                if(res.f == true ){
                    console.log(res)
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.selectPageAll()
                    //this.newDialog = false
                    this.closeDialog()
                }else{
                    this.$message.error(res.msg);
                }
            })
        },
        changeHandler(value) {
            //console.log('改变之后的值是:' + value)
            let data =  this.authTypeList
            let item = this.add.userList
　　　　　　 // 使用find方法根据id查询对应对象
            let a =  data.find((ele)=>{
                return ele.id == item
            });
            console.log(a) //1
            var arr3 =a
            if(!arr3.id){
                    this.add.targetContent = '',
                    this.add.customerName= ''
                    this.add.clearType = 2
                    this.disEdit = true
                }else{
                    this.add.targetContent = arr3.targetContent,
                    this.add.customerName= arr3.customerName
                    this.add.clearType = 1
                    this.add.projectName = arr3.projectName
                    this.disEdit = false
                    this.add.id = this.add.userList
                }
        },
        groupChange() {
            console.log("变化", this.add.userList);
            if (this.add.userList.length > 1) {
                this.add.userList.shift();
            }
            console.log(this.add.userList)
            var arr3 =[]
                this.add.userList.forEach((item) => {
					this.authTypeList.forEach((element) => {
						  if (item == element.id) {
							arr3.push(element)
						  }
					})
                })
                console.log(arr3)
                if(arr3.length == 0){
                    this.add.targetContent = '',
                    this.add.customerName= ''
                    //
                    //this.add.visitDateNew= ''
                    this.add.clearType = 2
                    this.disEdit = false
                }else{
                    this.add.targetContent = arr3[0].targetContent,
                    this.add.customerName= arr3[0].customerName
                    this.add.clearType = 1
                    this.add.projectName = arr3[0].projectName
                    this.disEdit = true
                    this.add.id = this.add.userList[0]
                }
        },

        //获得周计划列表
        getWeekPlan(year,week){
            var year = this.add.year
            var week = parseInt(this.add.week)
            var data = {
                year:year,
                week:week
            }
            console.log(data)
            ss.MuBiao.getListPlan(data).then(res => {
                console.log(res)
                if(res.f == true ){
                    console.log(res)
                    this.authTypeList = res.msg
                }else{
                    this.$message.error(res.msg);
                }
            })
        },

        deleteSingle(id){
            //
            var data = id
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    ss.MuBiao.delById(data).then(res => {
                        console.log(res)
                        if(res.f == true ){
                             this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.selectPageAll()
                        }else{
                            this.$message.error(res.msg);
                        }
                    })

                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        selectPageAll(){
            ss.MuBiao.checkPage(this.q).then(res => {
                console.log(res.msg)
                this.tableData = res.records
                this.q.total = res.total
                //this.listProject = res.msg
            })
        },
        getNowTime() {
            var now = new Date();
            var year = now.getFullYear(); //得到年份
            var month = now.getMonth(); //得到月份
            var date = now.getDate(); //得到日期
            month = month + 1;
            month = month.toString().padStart(2, "0");
            date = date.toString().padStart(2, "0");
            var defaultDate = `${year}-${month}-${date}`;
            this.$set(this.q, "visitDate", defaultDate);
            this.$set(this.add, "visitDateNew", defaultDate);
        },

        //新增日清
        create(){
            this.newDialog = true;
            this.titleDig="新建日计划"
            this.disEdit = false;
            this.add.week = this.weekList[0].week
            this.getWeekPlan()
        },
        getWeeks(y){
            ss.MuBiao.getWeekList({year:y}).then(rd => {
                this.weekList = rd;
            })
        },
        getWeeksBySelectYear(){
            this.getWeeks(this.add.year);
            ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
                this.addlianqunList = rd;
            })
        },
        selectWeek(){
            console.log(this.add.week)
            this.getWeekPlan()
        },
        getqWeeksBySelectYear(){
            this.getqWeeks(this.q.year,1);
        },
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        rest(){
            var pageSize=this.q.pageSize;
            var pageNo=this.q.pageNo;
            var total=this.q.total;
            this.q= {
                pageSize: pageSize,
                pageNo: pageNo,
                total:total,
                visitDate:''
            }
        },
        exit(){
            this.closeDialog()
        },
        closeDialog(){
            this.newDialog = false
            this.editDialog = false
            this.writeNissin = false
            this.xxx = '';//清空数据

            this.add.targetContent='',
            this.add.customerName='',
            this.add.visitDateNew='',
            this.add.clearType='2',
            this.add.projectName=''

            this.edit.targetContent='',
            this.edit.customerName='',
            this.edit.visitDateNew='',
            this.edit.projectName=''

        },
      entrypartner(){
        if (this.add.documentaryType == 1 || this.add.documentaryType == 3){
          this.add.partneritem = this.add.partner;
          this.add.partner = "";
        }
        if (this.add.documentaryType == 2 ){
          this.add.partner = this.add.partneritem;
        }
      },
      approve(){
        var data = this.multipleSelection
        console.log(data)
        this.approves(data);
      },
      approves(data){
        this.$confirm('请确定提交审批', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ss.loudnew.loudList(data).then(res => {
            console.log(res)
            if(res.f == true ){
              this.$message({
                type: 'success',
                message: '提交成功!'
              });
              this.handleFilter()
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审批'
          });
        });
      },
      genzongLiuch(v){
        console.log(v);
        this.instid = v;
        this.showhistory = true;
      },
      //获取单位名称信息
      selectDept(value){
        ss.nxAddress.getDeptList(value).then(rd =>{
          this.deptNameList = rd.msg;
        })
      },
      //省份选择器
      handleItemChange1(o){
        this.addUser.provinceId = o;
        this.address = _.find(this.shenglist,{code:this.addUser.provinceId});
        this.addUser.province = this.address.name;
        ss.Dictservice.areaTreelist({code:o}).then(rd => {
          console.log("rddddddd",rd.zlist)
          this.addUser.city = '';
          this.addUser.area = '';
          this.arealist2 = rd.zlist;
          this.arealist3 = [];
        })
      },
      handleItemChange2(o){
        this.addUser.cityId = o;
        this.address = _.find(this.arealist2,{code:this.addUser.cityId});
        this.addUser.city = this.address.name;
        this.arealist3 = _.find(this.arealist2,{code:o}).zlist
        console.log("arealist3",this.arealist3)
        this.arealist4 = []
      },
      handleItemChange3(o){
        this.addUser.areaId = o;
        this.address = _.find(this.arealist3,{code:this.addUser.areaId});
        this.addUser.area = this.address.name;
      },
      commitCreateLxr(v){
        if (!this.addLxr.fullName) {
          this.$message({
            type: "error",
            message: '姓名不能为空'
          });
          return false;
        }

        if (!this.addLxr.custName) {
          this.$message({
            type: "error",
            message: '客户名称不能为空'
          });
          return false;
        }
        ss.MuBiao.insertbcp(this.addLxr).then(res => {
          console.log(res)
          if (res.f == true) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
            // this.selectPageAll()
            //this.newDialog = false
            this.closeDialogLxr();
          } else {
            this.closeDialogLxr()
            this.$message.error(res.msg);
          }
        })

      },
      commitCreateUser(v){
        this.addUser.subFlag = '提交';
        this.addUser.countryId = '156';
        this.addUser.country = '中国';
        this.addUser.provinceId = this.addUser.provinceId.substring(0,6);
        this.addUser.cityId = this.addUser.cityId.substring(0,6);
        this.addUser.areaId = this.addUser.areaId.substring(0,6);
        this.addUser.parentCode = this.stVal;

        var data = this.addUser;
        ss.nxAddress.insertAddress(data).then(rd => {
          this.closeDialogUser();
        })
      },
      //取消
      exitLxr() {
        this.closeDialogLxr()
      },
      exitUser() {
        this.closeDialogUser()
      },
      //获取当前登录人创建的所有父级单位
      getParentInfo(){
        ss.nxAddress.getParentInfo().then(rd =>{
          this.options = rd.msg;
        })
      },
      // 关闭新建联系人 弹窗
      closeDialogLxr(){
              this.addLxr.fullName= '';
              this.addLxr.custName= '';
              this.addLxr.custCode= '';
              this.addLxr.leader= '';
              this.addLxr.dept= '';
              this.addLxr.job= '';
              this.addLxr.sex= 0;
              this.addLxr.mobilephone= '';
              this.addLxr.telephone= '';
              this.addLxr.email= '';
              this.addLxr.address= '';
              this.addLxr.birthday= '';
              this.addLxr.policyMaker= 0;
              this.addLxr.achievingRate= '';
              this.addLxr.finishSchool= '';
              this.addLxr.expertlevel= '';
              this.addLxr.interest= '';
              this.addLxr.project= '';
              this.addLxr.memo= '';
        this.newDialogLxr = false;
      },
      //关闭弹窗,清空数据
      closeDialogUser(){
        this.institutionalX = false
        this.newDialogLxr = false
        this.newDialogUser = false
        this.updateDialog = false
        this.insertFlag = false
        this.reFlag = false
        //清空数据
        this.addUser.deptName = '';
        this.addUser.deptType = '';
        this.addUser.phone = '';
        this.addUser.leader = '';
        this.addUser.email = '';
        this.addUser.province = '';
        this.addUser.provinceId  = '';
        this.addUser.city = '';
        this.addUser.cityId = '';
        this.addUser.area = '';
        this.addUser.areaId = '';
        this.addUser.landmark ='';
        this.addUser.address = '';
        this.addUser.parentCode = '';
        this.addUser.deptSourceChannel = '';
        this.stVal = null;
        this.addUser.schoolType = '';
      },
    },
    watch:{
        'add.customerName': {
            deep: true,
            handler: function (newVal,oldVal){
            this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
            var len = this.groupList.length;//groupList
            var arr = [];
            for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
                if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
                arr.push({
                    value:this.groupList[i].name,
                    id:this.groupList[i].id
                })
                }
            }
            this.groupArr = arr
            }
        },
    },
    created(){
        this.getParentInfo();
        this.getNowTime()
        this.selectPageAll()
        this.add.year =  this.yearList[0]
        this.getWeeks(new Date().getFullYear());
       // this.add.week = this.workList[0].week
       //  this.getOption()
        this.getProject()
        this.getDept();
    }
}
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:80px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
    /deep/ .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }

    .projectCon p{
      justify-content: space-between;
      align-items:center;
      font-size: 14px;
      border-bottom:#1b78e6 1px dashed;
      padding: 5px 0;
      margin: 0 auto 10px auto;
      color: #1b78e6;
    }
    .redx:before{
      content:"*";
      color:red;
    }
    /*.redx:before{*/
    /*  content:"注意：";*/
    /*  color:red;*/
    /*  　　}*/
</style>
